import axiosInstance from "../../../common/axiosInstance";
import { ForgotPasswordModel } from "../type/ForgotPasswordSchema";

// Forgot password function
export const forgotPassword = async (data: ForgotPasswordModel) => {
  const response = await axiosInstance.post("/auth/forgot-password", data);
  return response.data;
};
